export default __webpack_public_path__ + "static/media/MRI.40da8630.png";